<mat-table #table [dataSource]="dataSource">
  <ng-container matColumnDef="Active">
    <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
    <mat-cell *matCellDef="let user">
      <i *ngIf="user.Active" matTooltip="Aktivert" class="material-icons enabled">check_box</i>
      <i *ngIf="!user.Active" matTooltip="Deaktivert" class="material-icons disabled">indeterminate_check_box</i>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="Name">
    <mat-header-cell *matHeaderCellDef>Navn</mat-header-cell>
    <mat-cell *matCellDef="let user">{{user.Name}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Username">
    <mat-header-cell *matHeaderCellDef>Brukernavn</mat-header-cell>
    <mat-cell *matCellDef="let user">{{user.Username}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Type">
    <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
    <mat-cell *matCellDef="let user">{{user.Type | userTypeName}}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="editUser.emit(row)"></mat-row>
</mat-table>
